import React from 'react';

const EmptyPage: React.FC = () => {
    return (
        <p>
        </p>
    );
}

export default EmptyPage;